import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { debounce } from './globals/tools.js';

gsap.registerPlugin( ScrollTrigger );

gsap.to(".gsap-hero", {
    scrollTrigger: {
        toggleActions: "play none reverse none",
        trigger: ".gsap-video",
        start: 'top top',
        end: 'bottom -40%',
        markers: false,
        scrub: true,
    },
    y: '-100%',
    opacity: 0,
});

gsap.to(".gsap-video", {
    scrollTrigger: {
        toggleActions: "play none reverse none",
        trigger: ".gsap-video",
        start: 'top top',
        end: 'bottom center',
        markers: false,
        scrub: true,
    },
    width: '92%',
});

function gsapHandleScroll(){
    const scroll = window.scrollY;

    gsapVideos.forEach(video => {
        if (scroll > video.offsetHeight) {
            video.classList.remove('h-lvh-plus');
            video.classList.add('h-lvh-short');
        } else {
            video.classList.add('h-lvh-plus');
            video.classList.remove('h-lvh-short');
        }
    });
}

// // Debounced scroll event handler
const debouncedGSAPHandleScroll = debounce(gsapHandleScroll, 100);